import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { FormControl, FormGroup, Button, InputGroup } from "react-bootstrap";
import './SearchHero.css';
import './SearchOptions.css';
import axios from "axios";
import mixpanel from "mixpanel-browser";

class Newsletter extends Component {

	constructor() {
		super();
		this.state = { email: '', status: 'pristine', submitting: false };
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.subscriptionInputGroup = this.subscriptionInputGroup.bind(this);
		this.mixpanel = mixpanel;
	}

	handleSubmit(event) {
		event.preventDefault();        
        this.setState({submitting: true});

       	let that = this;

       	let params = {
       		email: this.state.email,
       		list: "Webfinery Newsletter"
       	}

        axios
            .post("/api/newsletter/subscriptions", params)
            .then(function(response) {            	
                that.mixpanel.track("Newsletter subscription", {
                    email: params.email,
                    list: params.list,
                    source: 'webfinery.com/search',
                    success: true
                });
                that.setState({ email: '', status: 'success', submitting: false });
            })
            .catch(function(error) {
                that.mixpanel.track("Newsletter subscription", {
                    email: params.email,
                    list: params.list,
                    source: 'webfinery.com/search',                   
                    success: false,
                    error: error
                });
                that.setState({ status: 'error', submitting: false });
            });
	}

	handleChange(event) {
		this.setState({email: event.target.value});
	}

	subscriptionInputGroup() {
		const searchLabel = this.state.submitting ? 'Subscribing...' : 'Subscribe';
		return (			
		    <InputGroup>
		        <FormControl
		            type="email"
		            placeholder="Work email address"
		            style={{borderColor: "#5bc0de"}}
		            onChange={this.handleChange}
		            required="required"
		        />
		        <InputGroup.Button>
		            <Button
		                disabled={this.state.submitting}
		                type="submit"
		                bsStyle="success"
		            >
		                {searchLabel}
		            </Button>
		        </InputGroup.Button>
		    </InputGroup>
	    )
	}

	successMessage() {
		return (
			<div className="feedbackMessage">Done!</div>
		);
	}

	errorMessage() {
		return (
			<div className="feedbackMessage">Oops, couldn't subscribe...</div>
		);
	}


	inputGroup() {
        if (this.state.status === 'pristine') {
        	return this.subscriptionInputGroup();
        } else if (this.state.status === 'success') {
        	return this.successMessage();
        } else {
        	return this.errorMessage();
        }
	}

	render() {

		return (
			<Grid>
				<Row>
					<Col sm={12}>
						<div className="lastCallHeader">
							<h3>Join Webfinery Newsletter</h3>
							<h4>Important announcements only</h4>
						</div>
					</Col>
				</Row>
				<Row>
					<Col sm={2}/>
					<Col sm={8}>						
						<div className="NewsletterSubscription">
			                <form onSubmit={this.handleSubmit}>
			                    <FormGroup>
			                    	{this.inputGroup()}
			                    </FormGroup>
			                </form>
			            </div>
		            </Col>
		            <Col sm={2}/>
	            </Row>
	            <Row>
	            	<h5>No spam ever. Instant opt-out any time.</h5>
	            </Row>
            </Grid>
		)
	}
}

export default Newsletter;







// WEBPACK FOOTER //
// ./src/Newsletter.js